export const searchFormOption = function () {
    return [
        {
            prop: 'keyword',
            label: '关键字',
            type: 'input',
            placeholder: '请输入车架号/车牌号',
            width: '20%'
        },
        {
            prop: 'orgNo',
            label: '出单机构',
            type: 'cascader',
            placeholder: '请选择内容',
            propConfig: {
                children: 'children',
                label: 'orgName',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
            },
            options: this.$store.state.app.orgList,
            width: '20%'
        },
        {
            prop: 'saleNo',
            label: '业务员',
            type: 'select',
            width: '20%',
            options: this.$store.state.app.salesmanList
        },
        {
            prop: 'status',
            label: '状态',
            type: 'select',
            width: '20%',
            options: this.$emun.status
        },
    ]
}

export const cashFormOption = function() {
    return [
      {
        prop: 'cashRebate',
        label: '费用政策(%)',
        type: 'input',
        placeholder: '请输入费用政策百分比'
      },
	  {
	    prop: 'netFee',
	    label: '净费',
	    type: 'input',
	    placeholder: '请输入净费'
	  },
      {
        prop: 'is_pass',
        label: '审核结果',
        type: 'radio',
        options: [
            {
                label: '通过',
                value: 1
            },
            {
                label: '不通过',
                value: 0
            }
        ]
      },
      {
        prop: 'auditRemark',
        label: '备注',
        type: 'textarea',
        placeholder: '请输入内容'
      },
    ]
  }

export default {}